export const selectSavedFilters = (state) => state.filters.nestedFilters.savedFilters;
export const selectCurrentFilter = (state) => state.filters.nestedFilters.currentFilters;
export const selectSavedFilter = (state) => state.filters.nestedFilters.savedFilters;
export const selectColumns = (state) => state.filters.nestedFilters.columns;
export const selectColumnsArray = (state) => state.filters.nestedFilters.filterProperties;
export const selectColumnsForSelect = (state) =>
  state.filters.nestedFilters.filterPropertiesForSelect;
